<template>
    <div class="dropdown-container box-drop">
        <div class="box-style month-border" @click="toggleDropdown">
            <div class="flex-container-drop">
                <div class="flex-right">
                    <span class="bold-drop">{{ formattedMonth }}</span>
                    <img class="down-arrow" src="../../public/img/chevron-down.svg" alt="Down Arrow">
                </div>
            </div>
        </div>
        <div v-if="isOpen" class="dropdown-list">
            <div
                style="padding-right: 45px; text-align: right;"
                v-for="(month, index) in reversedMonths"
                :key="index"
                @click="selectMonth(month)"
            >
                {{ month[0] }}, {{ month[2] }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedProductMonthFromParent: {
            type: Array,
            required: false,
            default: () => null
        }
    },
    data() {
        const currentYear = new Date().getFullYear();
        const currentMonthIndex = new Date().getMonth(); // 0 = January
        const previousYear = currentYear - 1;

        // Generate months for both the previous and current year
        const generateMonths = (year) => [
            ['Janeiro', '01', year], ['Fevereiro', '02', year], ['Março', '03', year],
            ['Abril', '04', year], ['Maio', '05', year], ['Junho', '06', year],
            ['Julho', '07', year], ['Agosto', '08', year], ['Setembro', '09', year],
            ['Outubro', '10', year], ['Novembro', '11', year], ['Dezembro', '12', year]
        ];

        const allMonths = [...generateMonths(previousYear), ...generateMonths(currentYear)];

        // Filter months up to the current month
        const filteredMonths = allMonths.filter(
            (month) => 
                (month[2] < currentYear) || 
                (month[2] === currentYear && parseInt(month[1], 10) <= currentMonthIndex + 1)
        );

        return {
            isOpen: false,
            selectedProductMonth: this.selectedProductMonthFromParent || filteredMonths[filteredMonths.length - 1], // Default to current month
            months: filteredMonths,
            currentMonthIndex
        };
    },
    computed: {
        reversedMonths() {
            return [...this.months].reverse(); // Reverse to display the most recent months first
        },
        formattedMonth() {
            return `${this.selectedProductMonth[0]}, ${this.selectedProductMonth[2]}`;
        }
    },
    watch: {
        selectedProductMonthFromParent(newVal) {
            if (newVal) {
                this.selectedProductMonth = newVal;
            }
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectMonth(month) {
            this.selectedProductMonth = month; // Update local state
            this.isOpen = false;

            // Emit the selected month and formatted value to the parent
            const formattedMonthYear = `${month[2]}${month[1]}`;
            this.$emit('productMonthSelectedFilter', { teste: formattedMonthYear, selectedProductMonth: month });
        }
    }
};
</script>

<style scoped>
.dropdown-container {
    border-radius: 5px;
    font-family: Arial, sans-serif;
    cursor: pointer;
    position: relative;
    width: 200px;
}

.flex-container-drop {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 0px;
    font-size: 18px;

    .flex-right {
        text-align: right !important;
        padding-right: 20px;
    }

    .flex-left {
        text-align: right;

    }
}

.dropdown-header {
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
}

.dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #F48C4F;
    border-radius: 12px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    font-size: 18px;
}

.dropdown-list div {
    padding: 8px 10px;
    cursor: pointer;
}

.dropdown-list div:hover {
    background-color: #f5f5f5;
}

.box-drop {

    .box-style {
        border-radius: 12px;
        border: 1px solid #E7D9D0;
        background-color: #fff;
    }

    .box-content {
        padding-left: 20px;
    }

    .box-no-pad {
        padding: 15px 0px 0px 20px !important
    }

    .box-no-pad-right {
        padding: 15px 20px 0px 0px !important
    }

    .box-pad {
        padding: 5px 0px 0px 20px;
        margin-bottom: 10px;
    }

    .box-content-right {
        padding-right: 20px;
    }
}

.month-menu {
    font-size: 18px;
    color: #000000b3;
}

.down-arrow {
    width: 16px;
    height: 16px;
}

.bold-drop {
    font-weight: 500;
    padding-right: 10px;
}
</style>
  